module.exports = __webpack_public_path__ + "img/layer-3.da186566.png";